import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';

import SupportAccessPanel from './SupportAccessPanel';

/**
 * YAC-2026-009 PR7b。運営の画面の「サポートの一覧」（どの会社・どの運営のものも）。今効いているものが既定で、
 * 終わったものも表示できる。どの運営のものも、ここから終わらせられる（PR7a の申し送り5）。
 */
const SupportAccessList: React.FC = () => {
  const { t } = useTranslation('layout');
  const titleId = useId();
  return (
    <section className="flex flex-col gap-4 px-4 py-3">
      <h1 id={titleId} className="text-title font-bold text-neutral/300">
        {t('support.list-title')}
      </h1>
      <p className="text-body-2 text-neutral/300">{t('support.list-lead')}</p>
      <div className="rounded-md bg-white p-6">
        <SupportAccessPanel labelledBy={titleId} />
      </div>
    </section>
  );
};

export default SupportAccessList;
